import { createSelector } from 'reselect'
import { listFeatureStateSelector } from './listFeatureStateSelector'

export const pageSizeSelector = createSelector(
  listFeatureStateSelector,
  state => state.size
)
